import { createContext, useContext, useState } from "react"

// Create the context
const BusinessContext = createContext()

// Custom hook to access UserContext
export const useBusiness = () => {
  return useContext(BusinessContext)
}

// Provider component
export const BusinessProvider = ({ children }) => {
  const [context_business, setBusiness] = useState(null)

  // Function to update user info
  const updateBusiness = (newBusinessData) => {
    setBusiness(newBusinessData)
  }

  return (
    <BusinessContext.Provider value={{ context_business, updateBusiness }}>
      {children}
    </BusinessContext.Provider>
  )
}
